import { HealthDashboardInfoStateData } from '@nirvana/shared/dtos/types/widgets/common';

export type GzGeneralDonutChartPayload = GeneralDonutChartInput | HealthDashboardInfoStateData;

export interface DonutSliceData {
  id: string;
  value: number;
  label: string;
  color?: string;
}

export interface GeneralDonutChartInput {
  data: DonutSliceData[];
  title: string;
}

export const EMPTY = 'empty';

export enum GzDonutChartEvents {
  OPEN_SIDE_PANEL_RISKS = 'openSidePanelRisks',
}

export interface PieChart {
  id: string;
  index: number;
  name: string;
  ratio: number;
  value: number;
}
